import { render, staticRenderFns } from "./ExampleBaseTableLayout.vue?vue&type=template&id=77f70636&scoped=true"
import script from "./ExampleBaseTableLayout.vue?vue&type=script&lang=js"
export * from "./ExampleBaseTableLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f70636",
  null
  
)

export default component.exports